import React from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";

const ImageUploadField = ({
  label,
  imageUri,
  handleImageInputChange
}) => {
  const hiddenImageInput = React.useRef(null);

  const handleUploadIconClick = (event) => {
    hiddenImageInput.current.click();
  };

  return (
    <>
      <div className="form-group">
        <label>{label}</label>
        <input
          type="file"
          ref={hiddenImageInput}
          accept="image/png, image/gif, image/jpeg"
          onChange={handleImageInputChange}
          style={{ display: "none" }}
        />
        <div className="image-upload-wrapper">
          <Button
            color="primary"
            style={{ marginRight: ".55rem", marginTop: ".25rem", height: "calc(1.5em + 0.75rem + 16px)" }}
            onClick={handleUploadIconClick}
          >
            Upload Image
          </Button>
          {imageUri !== undefined && imageUri !== '' &&
            <img width={55} height={55}
              src={imageUri}
              alt="avatar"
            />
          }
          {(imageUri === undefined || imageUri === '') &&
            <div style={{ marginTop: 17 }}>No file chosen</div>
          }
        </div>
      </div>
      <br />
    </>
  )
};

ImageUploadField.propTypes = {
  label: PropTypes.string.isRequired,
  imageUri: PropTypes.string,
  handleImageInputChange: PropTypes.func,
};

export default ImageUploadField;